exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label{\n  text-align:left\n}\nlegend{\n    margin-top: 40px;\n}   ", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/grant-form/household-member/household-member.component.css
// module id = 840
// module chunks = 1